import * as React from 'react';

import ChangePasswordContainer from '../containers/ChangePassword';

/**
 * パスワード変更画面
 * @param props
 */
const ChangePassword: React.FC<any> = props => {
	return <ChangePasswordContainer {...props} />;
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/pages/ChangePassword.tsx